import React from 'react'
import PropTypes from 'prop-types'

import StatusDisplay from 'components/StatusDisplay'
import ShowHide from 'components/ShowHide2'

class Displayer extends React.Component {
  render() {
    const { status } = this.props
    return (
      <div>
        <div style={{ textAlign: 'center', padding: status.isLoading ? 10 : 0 }}>
          <StatusDisplay status={status}>Algo deu errado</StatusDisplay>
        </div>
        <ShowHide show={!status.isLoading}>
          {this.props.children}
        </ShowHide>
      </div>
    )
  }
}

Displayer.propTypes = {
  status: PropTypes.object.isRequired,
  children: PropTypes.node,
}

export default Displayer


// WEBPACK FOOTER //
// ./src/components/Displayer/index.js